// based on https://gitlab-app.eng.qops.net/dsxeng/in-product-help-modal
import articles from './assets/recommended-articles-dynamic.json';
import articleData from './assets/article-data.json';
import comparator from '../../commonComparators/caseInsensitive';
import {
  PagesIcon,
  LightBulbIcon,
  VideoIcon,
  UserGroupIcon,
  EditorGenericIcon,
  NewspaperIcon,
} from '@qualtrics/ui-react/icons';
import { highlightSearch } from '../../highlighters/highlightSearch';

export function getDoctype(url) {
  const urlDoctypeMap = {
    'qualtrics.com/support/': 'Support Article',
    'qualtrics.com/community/': 'Community Post',
    'community.qualtrics.com': 'Community Post',
    'xminstitute.com/': 'Thought Leadership',
    'basecamp.qualtrics.com': 'XM Basecamp',
    'qualtrics.com/blog': 'Blog Post',
    'qualtrics.com/experience-management': 'Industry Knowledge',
  };

  for (let doctype in urlDoctypeMap) {
    if (url.indexOf(doctype) !== -1) {
      return urlDoctypeMap[doctype];
    }
  }
  return 'Support Article';
}

export function getArticleIcon(doctype) {
  switch (doctype) {
    case 'Blog Post':
      return EditorGenericIcon;
    case 'Industry Knowledge':
      return NewspaperIcon;
    case 'Thought Leadership':
      return LightBulbIcon;
    case 'Community Post':
      return UserGroupIcon;
    case 'XM Basecamp':
      return VideoIcon;
    default:
      return PagesIcon;
  }
}

const getContext = (v2Info) => {
  const { contextType } = v2Info;
  const resourceType = v2Info.resourceInfo?.resourceType;
  const subResourceType = v2Info.resourceInfo?.subResourceType;
  return { contextType, resourceType, subResourceType };
};

export const getDynamicContent = (v2Info) => {
  const { contextType, resourceType, subResourceType } = getContext(v2Info);
  try {
    return (
      articles[contextType][resourceType || ''][subResourceType || ''] ||
      articles.Homepage['']['']
    );
  } catch (e) {
    return articles.Homepage[''][''];
  }
};

const cleanUrl = (url) => {
  return url.split(/[?#]/)[0];
};

const createResults = (dynamicContent) => {
  return dynamicContent.articles.map((article, index) => {
    const cleanedUrl = cleanUrl(article);
    let title = '';
    for (let data of articleData) {
      if (data.url === cleanedUrl) {
        title = data.title;
      }
    }

    const doctype = getDoctype(article);

    return {
      label: title,
      searchLabel: title,
      subLabel: doctype,
      itemId: cleanedUrl,
      action: () => {
        window.location.href = article;
      },
      icon: {
        Icon: getArticleIcon(doctype),
        color: '#006FD3',
      },
    };
  });
};

/**
 * @type {CommandPalettePlugin}
 */
export const helpPlugin = {
  visExp: 'true',
  getResults: async ({ tabs }) => {
    const context = tabs.activeSuperTab.v2Info;
    const dynamicContent = getDynamicContent(context);
    const results = createResults(dynamicContent);
    return (searchString) =>
      Promise.resolve(
        results
          .filter((result) => comparator(result.searchLabel, searchString))
          .map((result) => ({
            ...result,
            label: highlightSearch(result.label, searchString),
          })),
      );
  },
};
